import type { PostHogProviderProps } from "@posthog/next";
import { isEuropeRegion } from "@/utils/common/region";

export type PostHogClientOptions = NonNullable<PostHogProviderProps["clientOptions"]>;

/**
 * Serializable PostHog client options for {@link PostHogProvider}.
 * `before_send` is applied client-side in {@link PostHogClientBridge} because
 * functions cannot cross the RSC boundary.
 */
export function getPostHogInitConfig(): PostHogClientOptions {
  return {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    capture_pageview: false,
    ...(isEuropeRegion()
      ? { cookieless_mode: "always" as const, enable_recording_console_log: false }
      : { enable_recording_console_log: true }),
  };
}
